import { useState } from "react";
import { motion } from "framer-motion";
import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { SectorMarquee } from "@/components/SectorMarquee";
import { Manifesto } from "@/components/Manifesto";
import { RegisterForm } from "@/components/RegisterForm";
import { Directory } from "@/components/Directory";
import { EventsBoard } from "@/components/EventsBoard";
import { Footer } from "@/components/Footer";

const EASE = [0.16, 1, 0.3, 1];

export default function Home() {
  const [refreshKey, setRefreshKey] = useState(0);

  return (
    <div className="min-h-screen bg-ivory" data-testid="home-page">
      <Header />
      <main>
        <Hero />
        <SectorMarquee />

        <Manifesto />

        <EventsBoard />

        <section id="register" className="border-t border-stone_warm py-28 lg:py-36" data-testid="register-section">
          <div className="mx-auto grid max-w-7xl grid-cols-1 gap-16 px-6 lg:grid-cols-12 lg:px-12">
            <div className="lg:col-span-5">
              <div className="lg:sticky lg:top-28">
                <motion.p
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, margin: "-80px" }}
                  transition={{ duration: 0.9, ease: EASE }}
                  className="mb-4 font-mono text-[11px] uppercase tracking-[0.3em] text-gold-dark"
                >
                  Registration
                </motion.p>
                <motion.h2
                  initial={{ opacity: 0, y: 24 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, margin: "-80px" }}
                  transition={{ duration: 0.9, ease: EASE, delay: 0.1 }}
                  className="font-serif text-4xl font-light tracking-tighter text-charcoal sm:text-5xl"
                >
                  Take your seat at <span className="italic text-gold-dark">the table.</span>
                </motion.h2>
                <motion.p
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, margin: "-80px" }}
                  transition={{ duration: 0.9, ease: EASE, delay: 0.2 }}
                  className="mt-6 max-w-md text-base leading-relaxed text-charcoal/70"
                >
                  Every sector is welcome. Once registered, your business appears instantly in the
                  Guild directory — visible to every member searching for a partner, a supplier,
                  or a referral.
                </motion.p>
                <motion.figure
                  initial={{ clipPath: "inset(0 0 100% 0)" }}
                  whileInView={{ clipPath: "inset(0 0 0% 0)" }}
                  viewport={{ once: true, margin: "-80px" }}
                  transition={{ duration: 1.3, ease: EASE, delay: 0.2 }}
                  className="mt-12 hidden overflow-hidden lg:block"
                  data-testid="register-image-frame"
                >
                  <img
                    src="https://images.pexels.com/photos/37228184/pexels-photo-37228184.jpeg"
                    alt="Modern church architecture in sunlight"
                    className="aspect-[4/5] w-full object-cover"
                  />
                </motion.figure>
                <p className="mt-4 hidden font-mono text-[10px] uppercase tracking-[0.28em] text-charcoal/45 lg:block">
                  Fig. 02 — Where we gather
                </p>
              </div>
            </div>
            <div className="lg:col-span-7">
              <RegisterForm onRegistered={() => setRefreshKey((k) => k + 1)} />
            </div>
          </div>
        </section>

        <Directory refreshKey={refreshKey} />
      </main>
      <Footer />
    </div>
  );
}
